export const createReferralResponse = {
  type: "object",
  required: [],
  additionalProperties: true,
};
